import BaseService from '../../services/BaseService'
import { IProfessor, IResultProfessorDTO } from './ProfessorType'

const authConfig = () => ({
  headers: {
    'Authorization': `Bearer ${localStorage.getItem('token')}`,
  },
})

const professorService = {
  getAll: async (): Promise<IResultProfessorDTO> => {
    const response = await BaseService.get(`/Professor/ObterTodos?pageNumber=1&pageSize=1000`, authConfig())
    const raw = response.data?.result || response.data
    const data = Array.isArray(raw) ? raw : []
    return { sucesso: true, data, mensagem: '' }
  },

  getById: async (id: string): Promise<IResultProfessorDTO> => {
    const response = await BaseService.get(`/Professor/ObterPorId?id=${id}`, authConfig())
    const raw = response.data?.result || response.data
    const data = raw ? [raw] : []
    return { sucesso: true, data, mensagem: '' }
  },

  cadastrar: async (obj: Omit<IProfessor, 'id' | 'dataCadastro'>): Promise<IResultProfessorDTO> => {
    const response = await BaseService.post('/Professor/Cadastrar', obj, authConfig())
    return { sucesso: true, data: [response.data], mensagem: 'Professor cadastrado com sucesso' }
  },

  atualizar: async (id: string, obj: Partial<IProfessor>): Promise<IResultProfessorDTO> => {
    const response = await BaseService.put('/Professor/Atualizar', { id, ...obj }, authConfig())
    return { sucesso: true, data: [response.data], mensagem: 'Professor atualizado com sucesso' }
  },

  inativar: async (id: string): Promise<IResultProfessorDTO> => {
    const response = await BaseService.put('/Professor/Inativar', { id }, authConfig())
    return { sucesso: true, data: [], mensagem: 'Professor inativado com sucesso' }
  },
}

export default professorService
